export const insurances_list = [
    { value: 'Orient Insurance', label: 'Orient Insurance' },
    { value: 'ADNIC', label: 'ADNIC' },
    { value: 'Oman Insurance Co', label: 'Oman Insurance Co' },
    { value: 'Al Ain Al Ahlia', label: 'Al Ain Al Ahlia' },
    { value: 'Emirates Insurance', label: 'Emirates Insurance' },
    { value: 'Salama', label: 'Salama' },
    { value: 'Dubai Insurance Co', label: 'Dubai Insurance Co' },
    { value: 'Al Buhaira National Insurance', label: 'Al Buhaira National Insurance' },
    { value: 'Ras Al Khaimah Insurance', label: 'Ras Al Khaimah Insurance' }
  ];

